import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  margin: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};

  ${props =>
    props.isPreviewActive &&
    css`
      background-color: ${props.theme.colors.background.secondary};
      border-radius: ${props => props.theme.primitives.radius.radius3};
    `}
`

export const CopyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export { PreviewToggleButton as PreviewButton } from '@/configuration/pages/ConfigurationPage/sharedStyles'
